import { FormControl } from '@angular/forms';
import creditCardType from 'credit-card-type';

const allowedCardBrands = ['visa', 'mastercard', 'american-express', 'diners-club', 'discover', 'jcb', 'unionpay', 'elo', 'hiper', 'hipercard'];

// Banese card
creditCardType.addCard({
  niceType: 'Banese',
  type: 'banese-card',
  patterns: [6361],
  gaps: [4, 8, 12],
  lengths: [16],
  code: { name: 'CVV', size: 3 }
});

export const creditCardValidator = (control: FormControl): { [invalidCreditCard: string]: boolean } => {
  const cardNumber = control.value.replace(/\D/g, '');
  const cardTypes = creditCardType(cardNumber);

  if ((cardNumber && cardNumber !== '') && cardTypes && cardTypes.length) {

    // if (!allowedCardBrands.includes(cardTypes[0].type)) {
    //   return { invalidBrandCard: true };
    // }

    if (!cardTypes[0].lengths.includes(cardNumber.length)) {
      return { invalidCreditCard: true };
    }
   }
};
